import { isReservedSlug } from "./reservedSlugs";

const KNOWN_BASE_DOMAINS = ["hom.owlen.ai", "owlen.ai"] as const;

export interface TenantContext {
  slug: string;
  baseDomain: string;
}

export function getTenantContext(hostname = window.location.hostname): TenantContext | null {
  const host = hostname.toLowerCase();

  for (const base of KNOWN_BASE_DOMAINS) {
    if (host === base) return null; 
    if (host.endsWith("." + base)) {
      const slug = host.slice(0, -(base.length + 1));
      if (!slug || slug.includes(".") || isReservedSlug(slug)) return null;
      return { slug, baseDomain: base };
    }
  }

  const devTenant = import.meta.env.VITE_DEV_TENANT as string | undefined;
  if (import.meta.env.DEV && devTenant) {
    return { slug: devTenant, baseDomain: "localhost" };
  }

  return null;
}

export function getTenantSlug(): string | null {
  return getTenantContext()?.slug ?? null;
}
